module.exports = new __parcel__URL__("Graphs1.d3f90817.png").toString();